import { render, staticRenderFns } from "./deliveryForm.vue?vue&type=template&id=04c66fb6&scoped=true"
import script from "./deliveryForm.vue?vue&type=script&lang=js"
export * from "./deliveryForm.vue?vue&type=script&lang=js"
import style0 from "./deliveryForm.vue?vue&type=style&index=0&id=04c66fb6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04c66fb6",
  null
  
)

export default component.exports